import { render } from "./SettingContainer.vue?vue&type=template&id=258f1ea4&ts=true"
import script from "./SettingContainer.vue?vue&type=script&lang=ts"
export * from "./SettingContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__